import typeCheck from 'common/util/typeCheck';
import {
  SR_API_ACTION_LEASE_DOCUMENT_GET_LIST,
} from 'api/actionTypes';

export default async function getById({ state, apiClient }, { householdListingId, refresh }) {
  typeCheck('householdListingId::PositiveNumber', householdListingId);
  typeCheck('refresh::Maybe Boolean', refresh);

  const leaseDocumentsPath = ['leases', 'documentsByHouseholdListingId', householdListingId];

  if (!refresh && state.get(leaseDocumentsPath)) {
    return state.get(leaseDocumentsPath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LEASE_DOCUMENT_GET_LIST,
    state: state,
    payload: {
      householdListingId,
    },
    onSuccess(leaseDocuments) {
      state.set(leaseDocumentsPath, leaseDocuments);
    },
  });
}
